import React from "react";
import { useDialogContext } from "../utils/dialog-context.tsx";
import { FullPageLayout } from "./full-page-layout.tsx";

interface AuthSectionLayout {
  children: React.ReactNode;
  outerContainerClassName?: string;
}

export const AuthSectionLayout: React.FC<AuthSectionLayout> = ({ children, outerContainerClassName }) => {
  const dialogContext = useDialogContext();

  // if in dialog, don't add layout wrappers
  if (dialogContext) {
    return <>{children} </>;
  }

  return (
    <FullPageLayout
      outerContainerClassName={outerContainerClassName}
      horizontalPadding="px-3.5 sm:px-7.5"
      verticalPadding="py-7.5 md:py-12 lg:py-14"
      maxWidthClassName="max-w-espc-max-content"
    >
      {children}
    </FullPageLayout>
  );
};
